export default {"src":"/_next/static/media/ic-congratulations.2168aeee.svg","height":466,"width":290,"blurWidth":0,"blurHeight":0};